<template>
  <BarChart
    v-if="
      Object.keys(quizResults).length > 0 &&
        Object.keys(quizResults.counts).length > 0
    "
    class="chart-container"
    :chartdata="chartDataQuizResults()"
    :options="quizResultOptions"
  />
</template>

<script>
import BarChart from "@/components/chart/BarChart";
import BarChartCommons from "@/components/chart/BarChartCommons";

function __blendColorsAt(color1, color2, weight) {
  var w1 = weight;
  var w2 = 1.0 - w1;
  var rgb = [
    Math.round(color1[0] * w1 + color2[0] * w2),
    Math.round(color1[1] * w1 + color2[1] * w2),
    Math.round(color1[2] * w1 + color2[2] * w2)
  ];
  return rgb;
}

function __colorPaletteQuiz(context) {
  var index = context.dataIndex;
  var value = context.dataset.data[index];
  const rgb = __blendColorsAt([0, 255, 0], [255, 0, 0], value / 100.0);
  const result = "rgba(" + rgb.join(",") + ",.55)";
  return result;
}

export default {
  name: "BoxWordStatisticsQuizChart",
  components: { BarChart },
  props: {
    quizResults: {
      type: Object,
      required: true
    },
    cards: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      quizResultOptions: {
        ...BarChartCommons.defaultChartOptions({
          xAxes: {
            ticks: {
              stepSize: 25,
              beginAtZero: true,
              max: 100,
              callback: function(value) {
                return value + "%";
              }
            }
          }
        })
      }
    };
  },
  methods: {
    chartDataQuizResults: function() {
      const data = {
        labels: [],
        datasets: [
          {
            barThickness: "flex",
            barPercentage: 0.99,
            borderColor: "rgba(0, 0, 0, 0.2)",
            borderWidth: 0.5,
            backgroundColor: __colorPaletteQuiz,
            data: []
          }
        ]
      };

      const counts = this.quizResults.counts;
      Object.keys(counts).forEach(w => {
        const stats = counts[w];
        const sum = stats.yes + stats.no;
        if (sum && sum > 0) {
          const percentage = (stats.yes / sum) * 100.0;
          data.datasets[0].data.push(percentage);
          data.labels.push(
            w +
              ": " +
              Math.round(percentage * 100) / 100.0 +
              "% " +
              (stats.yes + stats.no) +
              "×"
          );
        } else {
          data.datasets[0].data.push(0);
          data.labels.push(w);
        }
      });
      return data;
    }
  }
};
</script>
